var _rect, _path, _g, _path2, _g2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoModu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 350,
    height: 180,
    viewBox: "0 0 350 180",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 350,
    height: 180,
    rx: 32,
    fill: "#F5F5F5"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_583_2252",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 78,
    y: 70,
    width: 42,
    height: 39
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M82.8697 74.4193C87.8753 68.7372 96.0657 68.5364 101.235 74.0474L119.948 93.6593L107.427 107.24C105.381 109.568 94.8314 107.768 92.7241 105.514C92.7241 105.514 81.6762 92.8933 81.6149 92.8115C77.5435 87.836 78.1914 79.7146 82.8765 74.4193H82.8697Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_583_2252)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M92.7241 61.1958L104.972 74.6944L81.2398 100.747L68.9917 87.2484L92.7241 61.1958Z",
    fill: "url(#paint0_linear_583_2252)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_583_2252",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 81,
    y: 70,
    width: 45,
    height: 41
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M93.2425 106.131C98.3299 111.724 106.745 111.613 111.642 106.235L121.926 94.4326C126.938 88.7506 126.638 79.8705 121.476 74.3596C116.313 68.8411 108.232 68.7816 103.213 74.4637L88.1687 91.5618C86.1909 93.8079 83.6745 94.7896 81.6013 92.8039L93.2288 106.124L93.2425 106.131Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_583_2252)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M103.226 118.061L80.4897 93.5772L110.237 60.1841L132.974 84.6748L103.226 118.061Z",
    fill: "url(#paint1_linear_583_2252)"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M164.433 99.6363H177.813V109.186H184.612V99.6363H198.034V94.2666H164.433V99.6363Z",
    fill: "#009C75"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M196.322 77.7188V72.3491H172.978C172.296 72.3714 165.954 72.7582 165.954 80.0392V90.3918H196.322V85.0221H172.76V77.7262H196.322V77.7188Z",
    fill: "#009C75"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M149.587 96.7285H142.658V103.757H129.366V109.126H162.81V103.757H149.587V96.7285Z",
    fill: "#009C75"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M147.432 72.3867H138.041C137.359 72.409 131.01 72.7958 131.01 80.1363V94.6166H161.044V72.3867H147.432ZM154.238 89.2023H137.816V77.801H154.238V89.2023Z",
    fill: "#009C75"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M199.902 100.982H213.275V109.186H220.075V100.982H233.496V95.6128H199.902V100.982Z",
    fill: "#009C75"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M231.695 77.6002V72.3569H208.522C207.84 72.3792 201.505 72.7734 201.505 80.047V92.7721H231.695V87.6255H208.304V85.1118H231.238V80.1065H208.304V77.6002H231.695Z",
    fill: "#009C75"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M269.524 78.0983V77.9496C269.047 71.1445 262.773 71.1445 262.773 71.1445V84.182H259.37C258.899 80.2105 257.753 77.1612 255.912 75.0639C253.914 72.7956 251.213 71.6651 247.797 71.6651C244.025 71.6651 241.113 73.0559 239.061 75.8374C237.008 78.6264 235.992 82.7689 235.992 88.2799C235.992 93.7909 237.015 97.9408 239.061 100.722C241.113 103.511 244.019 104.902 247.797 104.902C251.213 104.902 253.921 103.749 255.933 101.436C257.944 99.1233 259.124 95.6873 259.479 91.1283C259.506 90.8011 259.533 90.4739 259.547 90.1392H262.773V109.178H269.531V78.0983H269.517H269.524ZM251.616 96.3046C250.709 98.1268 249.44 99.0341 247.797 99.0341C246.153 99.0341 244.891 98.1268 243.984 96.3046C243.077 94.4825 242.627 91.8126 242.627 88.2873C242.627 84.7621 243.084 82.0847 243.984 80.27C244.891 78.4479 246.153 77.5405 247.797 77.5405C249.44 77.5405 250.702 78.4479 251.616 80.27C252.509 82.0921 252.959 84.7695 252.959 88.2873C252.959 91.8051 252.509 94.49 251.616 96.3046Z",
    fill: "#009C75"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_583_2252",
    x1: 88.5498,
    y1: 82.6783,
    x2: 74.8791,
    y2: 70.1428,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#26741E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#387F1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#609713"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#82AC0D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#9EBD08"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#B4CA04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#C3D302"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#CCD900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#CFDB00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_583_2252",
    x1: 124.129,
    y1: 71.9557,
    x2: 91.695,
    y2: 102.284,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009C75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#029C75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#0A9F78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#17A37C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#2AAA82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#43B289"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#61BC93"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#6EC197"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#5BBA91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#2BAA82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009C75"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoModu);
export default __webpack_public_path__ + "static/media/logo_modu.df65267ddbd0f87ee72dc27aed2a56dd.svg";
export { ForwardRef as ReactComponent };